import { render, staticRenderFns } from "./PortalProposta.vue?vue&type=template&id=e70c0134&"
import script from "./PortalProposta.vue?vue&type=script&lang=js&"
export * from "./PortalProposta.vue?vue&type=script&lang=js&"
import style0 from "./PortalProposta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports